// 权限配置 
// permitConfig(2专家必传(无值null), 3管理员必传(无值null), 4辅导员必传(无值null), 必传(无值null))
import store from '@/store/index.js'

export function permitConfig(permit1, permit2, permit3, permit4, config) {
  if (!sessionStorage.getItem('loginMessage') || JSON.parse(sessionStorage.getItem('loginMessage'))?.login == 0) {
    return '无效调用'
  }
  let permitArr = store.state.permit
  let configArr = store.state.config
  let roletype = JSON.parse(sessionStorage.getItem('loginMessage')).roletype
  let permitFlag, configFlag;
  if (roletype === '1' && permit2) {
    permitFlag = permitArr.includes(permit1)
  } else if (roletype === '2' && permit2) {
    permitFlag = permitArr.includes(permit2)
  } else if (roletype === '3' && permit3) {
    permitFlag = permitArr.includes(permit3)
  } else if (roletype === '4' && permit4) {
    permitFlag = permitArr.includes(permit4)
  }
  if (configArr) {
    configArr.map(item => {
      if (item.name === config) {
        configFlag = item.value
      }
    })
  }
  if (permitFlag !== undefined && configFlag === undefined) {
    return permitFlag
  }
  if (permitFlag === undefined && configFlag !== undefined) {
    return configFlag
  }
  if (permitFlag !== undefined && configFlag !== undefined) {
    return {
      permitValue: permitFlag,
      configValue: configFlag
    }
  }
  if (permitFlag === undefined && configFlag === undefined) {
    return '无效调用'
  }
};

// export function permitConfigStu(permit, config) {
//   let permitFlag = store.state.permit.includes(permit)
//   let configFlag = false
//   if (store.state.config) {
//     store.state.config.map(item => {
//       if (item.name === config) {
//         configFlag = item.value
//       }
//     })
//   }
//   if (permit && !config) {
//     return permitFlag
//   }
//   if (!permit && config) {
//     return configFlag
//   }
//   if (permit && config) {
//     return {
//       permit: permitFlag,
//       config: configFlag
//     }
//   }
// };